import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import { 
  CheckCircleIcon, 
  XCircleIcon, 
  UserGroupIcon
} from '../../../../components/ui/Icons';
import { 
  Card, 
  CardHeader, 
  CardTitle, 
  CardContent, 
  Button, 
  Badge 
} from '../../../../components/ui';

const ApprovalActions = ({ 
  selectedRecord, 
  canTakeAction, 
  statusValue, 
  onOpenActionModal 
}) => {
  const { theme } = useTheme();

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm flex items-center">
          <CheckCircleIcon className="w-4 h-4 mr-2" />
          Actions
        </CardTitle>
      </CardHeader>
      <CardContent>
        {canTakeAction ? (
          <div className="grid grid-cols-1 gap-2">
            <Button
              onClick={() => onOpenActionModal('approve')}
              className="w-full justify-start"
              variant="default"
              size="sm"
            >
              <CheckCircleIcon className="w-4 h-4 mr-2" />
              Approve Request
            </Button>
            <Button
              onClick={() => onOpenActionModal('reject')}
              className="w-full justify-start"
              variant="destructive"
              size="sm"
            >
              <XCircleIcon className="w-4 h-4 mr-2" />
              Reject Request
            </Button>
            <Button
              onClick={() => onOpenActionModal('delegate')}
              className="w-full justify-start"
              variant="outline"
              size="sm"
            >
              <UserGroupIcon className="w-4 h-4 mr-2" />
              Delegate to Another User
            </Button>
          </div>
        ) : (
          <div className="text-center py-4">
            <p className={cn("text-sm", theme.text.secondary)}>
              No actions available for this status
            </p>
            <Badge variant="outline" className="mt-2">
              {statusValue?.charAt(0).toUpperCase() + statusValue?.slice(1) || 'Unknown'}
            </Badge>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ApprovalActions;
